import axios from 'axios'
import {ISSMaxWorkTimeTO, PlanMastTO, PlanPersRequestTO, PlanPersTO, PlanTagTO, PlanTemplTO} from 'generated/JavaTO'
import {PlanTempl} from 'generated/JavaTOmodifications'

export function getPlanMastVorlagenAPI() {
	return axios.get<PlanMastTO[]>('../json/planTemplate/load-planmast')
}

export function getPlanTageAPI() {
	return axios.get<PlanTagTO[]>('../json/planTemplate/load-plantage')
}

export function getPlanPersAPI(persNr?: number | null) {
	return axios.get<PlanPersTO[]>('../json/planTemplate/load-planpers', {params: {persNr}})
}

export function planZuweisenAPI(data: PlanPersRequestTO) {
	return axios.post<PlanPersTO>('../json/planTemplate/plan-zuweisen', data)
}

export function planPersDeleteAPI(id: number) {
	return axios.delete<void>('../json/planTemplate/plan-zuweisen', {params: {id}})
}

export function getPlanTemplatesAPI() {
	return axios.get<PlanTempl[]>('../json/planTemplate/templ')
}

export function createNewPlanAPI(data: PlanMastTO) {
	return axios.post<PlanMastTO>('../json/planTemplate/create-plan', data)
}

export function updatePlanMastAPI(data: PlanMastTO) {
	return axios.put<PlanMastTO>('../json/planTemplate/update-plan', data)
}

export function updatePlanMastZuAPI(data: PlanMastTO[]) {
	return axios.put<void>('../json/planTemplate/update-plans-visibiltiy', data)
}

export function createPlanTemplateAPI(data: PlanTemplTO) {
	return axios.post<PlanTemplTO>('../json/planTemplate/templ', data)
}

export function updatePlanTemplateAPI(data: PlanTemplTO) {
	return axios.put<PlanTemplTO>('../json/planTemplate/templ', data)
}

export function deletePlanTemplateAPI(id: number) {
	return axios.delete<void>('../json/planTemplate/templ', {params: {id}})
}

export const PlanTemplateSisNameUrl = '../json/planTemplate/templ'

export function getToleraAPI(persnr: number, datum: number) {
	return axios.get<ISSMaxWorkTimeTO>('../json/getIssWorkTime', {params: {persnr, datum}})
}
